export default "__VITE_ASSET__7eb44de7__"